import React, { Component } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import IconButton from '@material-ui/core/IconButton';

class checkoutBag extends Component {
    render() {
        return (
            // <IconButton aria-label="Delete">

            <SvgIcon height = '0' style={{width:'35px', height: this.props.height || '', color: this.props.color}} 
            fontSize='inherit' id='Layer_2' data-name='Layer 2' xmlns='http://www.w3.org/2000/svg'
            viewBox='290 200 145 292'>
    <defs />
    <path className='cls-1' d='M210.68 268.79h189.69l19.75 228.58H190.94l19.74-228.58z'
    />
    <path className='cls-1' d='M272 292.15c.17-3.14.18-17.58.64-32.63.72-23.77 5-51 31.08-52.2 33.12-1.56 34.5 34.75 33.92 63.14a238.09 238.09 0 0 0 1.41 31.45c1.34 7.4 8.52 4.88 8.52.16 0-6.19 0-16.28-.44-31.05-.9-30.21-1.41-71.47-41.64-70.33-36.87 1-41.27 31.21-41.65 59.47-.23 17.43-.95 36.26-.8 40.75.26 6.62 7.96 10.33 8.96-8.76z'
    />
    <circle className='cls-2' cx='266.59' cy='306.58' r='12.89' />
    <circle className='cls-2' cx='344.94' cy='306.58' r='12.89' />
            </SvgIcon>
            // </IconButton>
        );
    }
}

export default checkoutBag;



// WEBPACK FOOTER //
// ./src/assets/images/checkoutBag.jsx